<template>
  <section
    :style="{
        position: 'fixed',
        display: 'flex',
        top: `${content.y}px`,
        left: `${content.x}px`,
        zIndex: index,
        textAlign: content.align,
        transform: content.transform,
          flexDirection: 'column',
          display: 'flex',
          justifyContent: content.valign ? content.valign === 'top' ? 'flex-start' : content.valign === 'bottom' ? 'flex-end' : 'center': 'center',

        width: `${content.width || 200}px`,
        height: content.height ? `${content.height}px` : null,
        fontFamily: content.mainFont,
        fontSize: `${content.mainFontSize}px`,
        backgroundColor: (content.backgroundColor && content.backgroundColor.hexa) ? content.backgroundColor.hexa : null,
        color: (content.foreGroundColor && content.foreGroundColor.hexa) ? content.foreGroundColor.hexa : null,
    }"
  >
    <editor-content :editor="editor" class="content-editor" :style="{
      textAlign: content.align
    }"></editor-content>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

import {
  Editor,
  EditorContent,
  EditorFloatingMenu,
  EditorMenuBubble,
  EditorMenuBar
} from "tiptap";

import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Center
} from "tiptap-extensions";

export default {
  components: {
    EditorContent,
    EditorFloatingMenu,
    EditorMenuBubble,
    EditorMenuBar
  },

  props: {
    content: {
      type: Object,
      default: () => {}
    },
    action: {
      type: Function
    },
    isSelected: {
      type: Boolean
    },
    index: {
      type: Number
    }
  },

  data() {
    return {
      editor: null,
      x: 0,
      y: 0
    };
  },

  methods: {
    ...mapActions("editor", ["selectComponent", "attachInlineEditor"]),
    doSomething(val) {
      this.content.text = val.getHTML();
    }
  },

  watch: {
    isSelected: function(val) {
      if (!val) {
        this.action(2);
        this.attachInlineEditor(null);
      }
    }
  },

  mounted: function() {
    this.editor = new Editor({
      content: this.content.text,
      autoFocus: true,
      editable: true,
      onUpdate: this.doSomething,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History()
      ]
    });
    this.attachInlineEditor(this.isSelected ? this.editor : null);
  },

  beforeDestroy() {
    if (this.editor) this.editor.destroy();
  }
};
</script>

<style scoped lang="scss">
.content-editor {
  z-index: 999999;
}
</style>

